type scrollToTypes = {
	scrollDir: number,
	lastScrollTop: number
}

const getScrollDirection = (localScrollInfo: scrollToTypes) => {
	let topState = window.pageYOffset || document.documentElement.scrollTop;
	localScrollInfo.scrollDir = topState > localScrollInfo.lastScrollTop ? 1 : -1;
	localScrollInfo.lastScrollTop = topState <= 0 ? 0 : topState;
	return localScrollInfo;
};

export {
	getScrollDirection,
	scrollToTypes
}
